import { HookFormResolver } from '@dec/shared';
import TaxReturnForm from 'app/modules/FormDefinition/components/Form';

import { type TaxReturnSummary } from '../../../models/TaxReturn';

interface TaxReturnBodyProps {
  content: TaxReturnSummary;
}

export const TaxReturnBody = ({ content }: TaxReturnBodyProps) => {
  const noop = () => undefined;

  return (
    <HookFormResolver onSubmit={noop}>
      {() => {
        return (
          <TaxReturnForm
            submit={noop}
            readOnly={true}
            defaultValue={content?.cells}
            version={content.formVersionId}
          />
        );
      }}
    </HookFormResolver>
  );
};
